import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ApplicationDropdownNavigation from "../../../clients/applications/application/components/application-dropdown-navigation";
import ApplicationForm from "../../../clients/applications/application/components/application-form";
import ApplicationFlowDropdown from "../../../clients/applications/application/components/header-components/application-flow-dropdown";
import ApplicationFormOverrides from "./application-form-overrides";
import { mapMutations, mapActions, mapState, mapGetters } from "vuex";
import { SET_VISIBILITY_CURRENT_APPLICATION, CLEAR_CURRENT_SCHEMA, SET_CURRENT_APPLICATION_ID } from "../../../clients/applications/application/store/application-mutations";
import { LOAD_EMPTY_APPLICATION, LOAD_CUSTOMIZATION_SCHEMA, RESET_CUSTOMIZATION_SCHEMA } from "../../../clients/applications/application/store/application-actions";
import { handleAlignment } from "@Broker/js/custom/utils";
import ApplicationPageLoader from "@Broker/@Modules/clients/applications/application/components/page-loaders/application-page-loader.vue";
import { CURRENT_APPLICATION } from "@Broker/@Modules/clients/applications/application/store/application-getters";
import { defineComponent } from "@vue/composition-api";
import Err from "@Broker/@Routes/error";
export default defineComponent({
  name: "ApplicationVisibility",
  components: {
    ApplicationDropdownNavigation,
    ApplicationForm,
    ApplicationFlowDropdown,
    ApplicationFormOverrides,
    ApplicationPageLoader
  },
  props: {
    isBrokerage: {
      type: Boolean,
      required: true
    },
    resetting: {
      type: Boolean,
      required: true
    }
  },
  data() {
    const pages = ["main-applicant", "co-applicants", "property", "other-properties", "mortgage-details", "documents", "filogix"];
    const flows = [{
      title: this.$t("application-flow.flows.purchase-approval"),
      key: "purchase-approval"
    }, {
      title: this.$t("application-flow.flows.refinance-approval"),
      key: "refinance-approval"
    }, {
      title: this.$t("application-flow.flows.purchase-preapproval"),
      key: "purchase-preapproval"
    }, {
      title: this.$t("application-flow.flows.switch-transfer"),
      key: "switch-transfer"
    }];
    return {
      loading: true,
      pages,
      flows,
      currentFlow: flows[0],
      currentPage: pages[0]
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters("ApplicationStore", [CURRENT_APPLICATION])), mapState("ApplicationStore", {
    updatedAt(state) {
      return state.customizationSchema.updatedAt;
    },
    saving(state) {
      return state.schema.saving;
    }
  })), {}, {
    applicationInfo() {
      return this.CURRENT_APPLICATION;
    },
    flow() {
      return this.CURRENT_APPLICATION.flow;
    }
  }),
  watch: {
    flow(val) {
      var _context;
      this.currentFlow = _findInstanceProperty(_context = this.flows).call(_context, ({
        key
      }) => key === val);
    },
    resetting(value) {
      if (value) {
        this.handleReset();
      }
    }
  },
  beforeMount() {
    $(".nav-item").removeClass("navbar-active");
    $("#application-form").addClass("navbar-active");
    window.addEventListener("beforeunload", this.confirmExit);
  },
  async mounted() {
    this.loading = true;
    await this.LOAD_CUSTOMIZATION_SCHEMA({
      isBrokerage: this.isBrokerage
    });
    this.LOAD_EMPTY_APPLICATION({
      flow: this.currentFlow.key,
      isBrokerage: this.isBrokerage,
      ignoreEmptyCheck: true
    }).then(() => {
      this.$nextTick(() => {
        this.SET_VISIBILITY_CURRENT_APPLICATION({
          flow: this.currentFlow.key
        });
        handleAlignment("application-form");
        this.loading = false;
      });
    });
  },
  destroyed() {
    window.removeEventListener("beforeunload", this.confirmExit);
  },
  deactivated() {
    window.removeEventListener("beforeunload", this.confirmExit);
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapMutations("ApplicationStore", [SET_VISIBILITY_CURRENT_APPLICATION, CLEAR_CURRENT_SCHEMA, SET_CURRENT_APPLICATION_ID])), mapActions("ApplicationStore", [LOAD_EMPTY_APPLICATION, LOAD_CUSTOMIZATION_SCHEMA, RESET_CUSTOMIZATION_SCHEMA])), {}, {
    confirmExit(event) {
      if (this.saving) {
        const confirmationMessage = this.$t("global.phrases.youHaveUnsavedChanges");
        event.returnValue = confirmationMessage; // Gecko, Trident, Chrome 34+
        return confirmationMessage; // Gecko, WebKit, Chrome <34
      }
    },
    handlePageChange(page) {
      this.currentPage = page;
      $(this.$refs.mortgageContainer).scrollTop(0);
    },
    formatTimeAgo(value) {
      return this.$options.filters.formatTimeAgo(value);
    },
    async handleReset() {
      this.loading = true;
      try {
        await this.RESET_CUSTOMIZATION_SCHEMA({
          isBrokerage: this.isBrokerage
        });
        this.$emit("finish-resetting", true);
      } catch (error) {
        this.$emit("finish-resetting", false);
        Err.handle(error);
      } finally {
        this.loading = false;
      }
    }
  })
});